/**
 * local storage key and value for showMFAAllSetModal (true when user first complete MFA)
 */
export const SHOW_MFA_ALL_SET_MODAL = {
  key: "showMFAAllSetModal",
  value: "true",
};
